import React, { useEffect } from 'react';
import { Html5QrcodeScanner } from 'html5-qrcode';

function TabletMode({ onScanResult, eventId }) {
    useEffect(() => {
        const qrScanner = new Html5QrcodeScanner(
            'qr-reader',
            { 
                fps: 10, 
                qrbox: { width: 250, height: 250 },
                aspectRatio: 1.0
            },
            false
        );

        qrScanner.render(
            (decodedText) => {
                console.log('QR Code scanned:', decodedText);
                onScanResult(decodedText);
                qrScanner.pause(true);
                setTimeout(() => {
                    if (qrScanner) {
                        qrScanner.resume();
                    }
                }, 2000);
            },
            (error) => {
                // Ignore scanning errors (happens continuously)
            }
        );

        return () => {
            if (qrScanner) {
                qrScanner.clear().catch(console.error);
            }
        };
    }, [onScanResult]);

    return (
        <div className="camera-container">
            <div id="qr-reader"></div>
        </div>
    );
}

export default TabletMode;
